import { Component, ElementRef, ViewChild } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { MenuItem } from 'primeng/api';
import { DataService } from 'src/app/services/data.service';
import { data_fields } from 'src/app/misc/interface/data';
import { GlobalConstants } from 'src/app/services/global-constants';
import { cloneDeep } from 'lodash';
import { PermissionHandlerService } from 'src/app/services/permission-handler.service';
import { PermissionLoaderService } from 'src/app/services/permission-loader.service';

@Component({
  selector: 'app-all-data-view',
  templateUrl: './all-data-view.component.html',
  standalone: false,
  styleUrls: [
    './all-data-view.component.scss',
    '../category/search-result/search-result.component.scss',
    '../category/data-view/data-view.component.scss',
  ]
})
export class AllDataViewComponent {
  random(min: number, max: number) { // min and max included 
    return Math.floor(Math.random() * (max - min + 1) + min)
  }
  sortFiled(fileds: any): Array<any> {
    return fileds?.sort((a: any, b: any) => {
      if (a.label?.priority && b.label?.priority) {
        return a.label?.priority - b.label?.priority;
      } else {
        return 0;
      }
    });
  }
  page_heading = "دليل الخدمات الحكومية";
  page_subheading = "المعرفة | التدريب | التطوير";

  data_type: string = "جميع الكيانات والوزارات";

  gotoLink: string = '/all-data-view'

  ou_object: any = {}

  ou = 0

  items: any = []
  dataitems: any;

  breadcrumbs: MenuItem[] = []
  data: any;

  fieldTypes: any[] = [];
  isLoggedIn = JSON.parse(localStorage.getItem('isLoggedIn') || "false");
  GlobalConstants = GlobalConstants
  datatypes: any;
  currentTypeFilter: any = "service";
  currentTypeFilter_arabic: any = "الخدمات";
  items_copy: any;
  dataitems_copy: any;

  processing = false;
  tableofItems: {
    heading: any; heading_icon: any; subheadings: {
      subheading: any; subheading_icon: any; items: {
        item_num: any; subsubheading: any; subsubheading_icon: any; title: any; id: any;
      }[];
    }[];
  }[] = [];

  constructor(
    private route: ActivatedRoute,
    private dataService: DataService,
    private permissionService: PermissionHandlerService,
    private permissionLoader: PermissionLoaderService
  ) { }

  ngOnInit() {

    if (this.fieldTypes.length == 0) {
      this.fetchFieldType();
    }



    // Subscribe to the route parameter changes
    this.route.queryParams.subscribe(async params => {

      this.dataitems = null;
      this.data = null;


      // Check if the 'id' parameter is present
      if (params['id']) {
        // If 'id' parameter is present, assign its value to the 'id' variable
        this.ou = params['id'];

        console.log("PARAMS ========>", params)

      } else {
        // If 'id' parameter is not present, set default data (e.g., 'defaultId')
        this.ou = 0;
      }
      this.getStructuredData(params)

      this.permissionLoader.getState().subscribe(e => {
        this.getStructuredData(params)
      })
    });
  }

  getStructuredData(params: any) {
    this.getOu().then(async e => {
      console.log("dataitems", this.dataitems)

      this.dataitems_copy = cloneDeep(this.dataitems)

      this.datatypes = await this.getCountOfData();

      this.applyTypeFilter(this.currentTypeFilter);


      if (params['type']) {

        let filtered = this.datatypes.filter((item: any) => item.name == params['type'])

        if (filtered[0]) {

          this.currentTypeFilter = filtered[0].name;
          this.currentTypeFilter_arabic = filtered[0].arabic;

        } else {

          this.currentTypeFilter = this.datatypes[0].name;
          this.currentTypeFilter_arabic = this.datatypes[0].arabic;

        }

      } else {

        this.currentTypeFilter = this.datatypes[0].name;
        this.currentTypeFilter_arabic = this.datatypes[0].arabic;

      }

    })
  }

  hasPermission(unit: string, flag: string) {
    return this.permissionService.hasPermission(unit, flag)
  }

  async getOu() {
    try {

      console.log("OUUUUUÙ", this.ou)
      let link = this.ou === 0 ? 'ou/parent' : 'ou/byId?id=' + this.ou;

      let res = await this.dataService.getData(link);
      console.log(res)

      if (res.error) {
        return
      } else {

        if (this.ou != 0) {
          this.page_heading = res.data[0].name
          if (this.isLoggedIn) {
            this.items = res.data[0].children
              .filter((item: any) => (Object.keys(item.data_counter).length > 0 && this.permissionService.content.includes(item._id)))
          } else {
            this.items = res.data[0].children
              .filter((item: any) => (Object.keys(item.data_counter).length > 0 && (this.permissionService.payload.dataView.allOus.includes(item._id) || this.permissionService.payload.dataView.signedOus.includes(item._id))))
          }
          this.ou_object = {
            name: res.data[0].name,
            image_sq: res.data[0].image_sq,
            image: res.data[0].image
          }
          this.dataitems = await (this.isLoggedIn ? this.getdata() : this.getdataSigned())
          if (this.dataitems && this.dataitems.length > 0) {
            if (this.isLoggedIn) {
              this.dataitems = this.dataitems
                .filter((e: any) => this.permissionService.content.includes(e.ous))
            }
          }

          this.breadcrumbs = [];

          this.breadcrumbs.push({
            label: "دليل الخدمات الحكومية",
            icon: "pi pi-home",
            url: "/all-data-view"
          });

          if (res.data[0].grandparent) {
            this.breadcrumbs.push({
              id: res.data[0].grandparent.id,
              label: res.data[0].grandparent.name,
              icon: res.data[0].grandparent.image_sq,
              url: "/all-data-view?id=" + res.data[0].grandparent.id
            });
          }

          if (res.data[0].parent) {
            this.breadcrumbs.push({
              id: res.data[0].parent.id,
              label: res.data[0].parent.name,
              icon: res.data[0].parent.image_sq,
              url: "/all-data-view?id=" + res.data[0].parent.id
            });

            this.page_subheading = res.data[0].parent.name
          }

          this.breadcrumbs.push({
            id: res.data[0].id,
            label: res.data[0].name,
            icon: res.data[0].image_sq,
            url: "/all-data-view?id=" + res.data[0].id
          });



        } else {

          this.page_heading = "دليل الخدمات الحكومية";
          this.page_subheading = "المعرفة | التدريب | التطوير";

          if (this.isLoggedIn) {
            this.items = res.data
              .filter((e: any) => this.permissionService.content.includes(e._id))
          } else {
            this.items = res.data
              .filter((item: any) => (this.permissionService.payload.dataView.allOus.includes(item._id) || this.permissionService.payload.dataView.signedOus.includes(item._id)));
          }
          this.ou_object = {
            name: "دليل الخدمات الحكومية",
            image_sq: "pi pi-home",
            image: "pi pi-home"
          }

          this.breadcrumbs = [];

          this.breadcrumbs.push({
            label: "دليل الخدمات الحكومية",
            icon: "pi pi-home",
            url: "/all-data-view"
          });
        }

      }

      this.items_copy = cloneDeep(this.items);

    } catch (error) {

      return

    }

  }


  hasDefaultPrintPermission() {
    return this.permissionService.payload.dataView.allowPrint;
  }


  async getdata() {
    try {

      let url = 'ou/getDataFromOuId?id=' + this.ou
      let res = await this.dataService.getData(url)

      return res.data

    } catch (error) {
      return
    }
  }

  async getdataSigned() {
    try {
      let data = { signedArray: this.permissionService.payload.dataView.signedOus, unsignedArray: this.permissionService.payload.dataView.allOus }
      let url = 'ou/getDataFromOuId?id=' + this.ou
      let res = await this.dataService.postData(url, data)
      return res.data

    } catch (error) {
      return
    }
  }

  async getPrintDataView(): Promise<void> {
    try {

      this.processing = true;

      let ouid = Number(this.ou)
      let query: any;
      query = ouid != 0 ? { "breadcrumbs.id": ouid, "type.name": this.currentTypeFilter, 
        "active": true,
        "tempInactive": false
      } : { "type.name": this.currentTypeFilter, "active": true,
        "tempInactive": false }

      if (!this.isLoggedIn) {
        let data = { signedArray: this.permissionService.payload.dataView.signedOus, unsignedArray: this.permissionService.payload.dataView.allOus }
        query.unsignedArray = data.unsignedArray;
        query.signedArray = data.signedArray;
      }
      await this.dataService.postData('data/data-view', query).then((res: any) => {
        this.processing = false;

        this.data = res.data?.map((currentItem: any) => {
          currentItem.fields?.sort((a: data_fields, b: data_fields) => {
            if (a.label?.priority && b.label?.priority) {
              return a.label?.priority - b.label?.priority;
            } else {
              return 0;
            }
          });

          currentItem.breadcrumbs.sort((a: any, b: any) => {
            return b.depth - a.depth;
          });
          return currentItem;
        });

        let tableofcontext: any = []

        this.data.forEach((item: any, index: number) => {

          tableofcontext.push({
            heading: item.breadcrumbs[0].label,
            heading_icon: item.breadcrumbs[0].icon,
            subheading: item.breadcrumbs[1] ? item.breadcrumbs[1].label : null,
            subheading_icon: item.breadcrumbs[1] ? item.breadcrumbs[1].icon : null,
            subsubheading: item.breadcrumbs[2] ? item.breadcrumbs[2].label : null,
            subsubheading_icon: item.breadcrumbs[2] ? item.breadcrumbs[2].icon : null,
            title: item.name,
            id: item.id,
            item_num: index
          })

        });

        console.log("table of context", tableofcontext)

        let output: { heading: any; heading_icon: any; subheadings: { subheading: any; subheading_icon: any; items: { subsubheading: any; subsubheading_icon: any; title: any; id: any; item_num: number }[]; }[]; }[] = []

        tableofcontext.forEach((item: any) => {
          const existingHeading = output.find((group) => group.heading === item.heading);

          if (existingHeading) {
            const existingSubheading = existingHeading.subheadings.find((subgroup) => subgroup.subheading === item.subheading);

            if (existingSubheading) {
              existingSubheading.items.push({
                subsubheading: item.subsubheading,
                subsubheading_icon: item.subsubheading_icon,
                title: item.title,
                id: item.id,
                item_num: item.item_num
              });
            } else {
              existingHeading.subheadings.push({
                subheading: item.subheading,
                subheading_icon: item.subheading_icon,
                items: [
                  {
                    subsubheading: item.subsubheading,
                    subsubheading_icon: item.subsubheading_icon,
                    title: item.title,
                    id: item.id,
                    item_num: item.item_num
                  },
                ],
              });
            }
          } else {
            output.push({
              heading: item.heading,
              heading_icon: item.heading_icon,
              subheadings: [
                {
                  subheading: item.subheading,
                  subheading_icon: item.subheading_icon,
                  items: [
                    {
                      subsubheading: item.subsubheading,
                      subsubheading_icon: item.subsubheading_icon,
                      title: item.title,
                      id: item.id,
                      item_num: item.item_num
                    },
                  ],
                },
              ],
            });
          }
        });

        console.log("Output:", output);

        this.tableofItems = output;

      });

    } catch (e) {
      console.log(e)
    }
  }

  sortByDepth(items: any): any {
    // console.log(items);
    if (items) {
      return items.sort((a: any, b: any) => {
        return b.depth - a.depth;
      });
    } else {
      return [];
    }
  }

  checkisImg(arg0: string | undefined): any {
    if (arg0) {
      return /\.(jpg|jpeg|png|gif|svg)/.test(arg0);
    } else {
      return false;
    }
  }

  getFieldType(type: any) {
    const fieldType = this.fieldTypes.find((item: any) => item._id == type);
    return fieldType ? fieldType.name : 'Unknown';
  }

  private async fetchFieldType(): Promise<void> {
    let res = await this.dataService.postData('field-type/get/', {
      active: true,
    });
    // console.log(res.data);
    if (res.error) {
      return;
    }
    this.fieldTypes = res.data;
  }

  async getCountOfData() {
    let datatypes = await this.getDataTypes()
    let sumOfProperties = this.calculateSumOfProperties(this.items);

    let output: any = []

    if (this.dataitems && this.dataitems.length > 0) {
      this.dataitems.forEach((item: any) => {
        if (sumOfProperties[item.type.arabic]) {
          sumOfProperties[item.type.arabic]++;
        } else {
          sumOfProperties[item.type.arabic] = 1;
        }
      });
    }

    datatypes.forEach((item: any) => {
      if (sumOfProperties[item.arabic]) {
        item.count = sumOfProperties[item.arabic];
        output.push(item)
      }
    });



    console.log("sumOfProperties", output)
    console.log("output", datatypes)

    return output;
  }

  async getDataTypes() {
    let res = await this.dataService.postData('data-type/get?offset=10&page=1', {});

    if (res.error) {
      return;
    }

    return res.data;
  }

  checkOuIdExists(id: string) {
    return this.permissionService.payload.dataView.signedOus.includes(id)
  }

  // Function to calculate the sum of each property inside data_counter
  calculateSumOfProperties(items: any[]): Record<string, number> {
    const result: Record<string, number> = {};

    if (this.isLoggedIn) {
      // Iterate through each object in the items array
      items.forEach(item => {
        let dataCounter: any;
        if (item.data_object) {
          dataCounter = item.data_object;
        } else {
          dataCounter = item.data_counter;
        }




        // Iterate through each property in data_counter
        for (const property in dataCounter) {
          if (dataCounter.hasOwnProperty(property)) {
            // Add the value to the corresponding property in the result
            result[property] = (result[property] || 0) + dataCounter[property];
          }
        }
      });

      return result;
    } else {
      // Iterate through each object in the items array
      items.forEach(item => {
        let dataCounter: any;
        if (this.checkOuIdExists(item._id)) {
          if (!!item.data_counter_signed) {
            dataCounter = item.data_counter_signed;
          }
        } else {
          if (item.data_object) {
            dataCounter = item.data_object;
          } else {
            dataCounter = item.data_counter
          }
        }

        // Iterate through each property in data_counter
        for (const property in dataCounter) {
          if (dataCounter.hasOwnProperty(property)) {
            // Add the value to the corresponding property in the result
            result[property] = (result[property] || 0) + dataCounter[property];
          }
        }
      });

      return result;
    }
  }

  applyTypeFilter(arg0: any) {

    this.currentTypeFilter = arg0;

    this.data = null;

    this.items = cloneDeep(this.items_copy);

    let filtered = this.datatypes.filter((item: any) => item.name == arg0)

    if( filtered[0]) {
      this.currentTypeFilter_arabic = filtered[0].arabic;
    } else {
      this.currentTypeFilter_arabic = "الأسئلة الشائعة";
     }

  
    this.items = this.items.filter((item: any) => {

      // Check if the key is present in the data_object property
      if (item.data_object && item.data_object[filtered[0].arabic]) {
        return true;
      } else if (item.data_counter && item.data_counter[filtered[0].arabic]) {
        return true;
      }

      return false;
    });

    console.log("filtered =====>", filtered)
    console.log("filtered =====>", this.items);

    this.dataitems = cloneDeep(this.dataitems_copy);

    this.dataitems = this.dataitems?.filter((item: any) => {
      if (item.type.name == arg0) {
        return true
      } else {
        return false
      }
    });

  }

  // Get references to the bounding box and text elements
  @ViewChild('boundingBox') boundingBox!: ElementRef<SVGRectElement>;
  @ViewChild('dynamicText') dynamicText!: ElementRef<SVGTextElement>;

  // Function to adjust font size dynamically
  adjustFontSize() {
    const boundingBoxWidth = this.boundingBox.nativeElement.getAttribute('width');
    const boundingBoxHeight = this.boundingBox.nativeElement.getAttribute('height');

    // Set your desired initial font size
    let fontSize: number = 20;

    this.dynamicText.nativeElement.setAttribute('font-size', fontSize.toString());

    // Check if the text overflows the bounding box
    while (
      this.dynamicText.nativeElement.getBBox().width > Number(boundingBoxWidth) ||
      this.dynamicText.nativeElement.getBBox().height > Number(boundingBoxHeight)
    ) {
      // Reduce the font size until it fits
      fontSize -= 1;
      this.dynamicText.nativeElement.setAttribute('font-size', fontSize.toString());
    }

  }

}

interface TableOfContentsItem {
  heading: string;
  heading_icon: string;
  subheading?: string;
  subheading_icon: string;
  subsubheading: string;
  subsubheading_icon: string;
  title: string;
  id: number;
}